import React, { useEffect, useState } from 'react';
import { TournamentCountdown } from '../TournamentCountdown/TournamentCountdown';
import { useSocket } from 'utils/hooks/useSocket';
import { formatCurrency } from 'utils';
import Cookies from 'js-cookie';
import { useTournament } from 'context/TournamentContext';
import LogoDetails from '../../../assets/resultsPhoto.png';
import LogoBanner from '../../../assets/Banner/BLK_LOGO_WORDMARK_WALLET_NEG.png';

import {
  Title,
  SubTitle,
  Row,
  ContentPhoto,
  ContentResults,
  TournamentRank,
  LineText,
  TournamentList,
  NickName,
  Percent,
  Amount,
  TournamentBlet,
  WrappList,
  BeltBottom,
  Banner,
} from './styled';
import { getTournamentRanking } from 'api/tournamentService';
import type { RankingEntry } from 'types/tournament';
import { CASH_TICKER } from 'utils/cash';

const TournamentRanking = () => {
  const { tournamentRanking, tournamentDetails } = useSocket() as { tournamentRanking: RankingEntry[], tournamentDetails: any };
  const username = localStorage.getItem('username') ?? Cookies.get('username');
  const { tournamentStatus } = useTournament();
  const [priceReward, setPriceReward] = useState<string | null>(null);
  const [localTournamentRanking, setLocalTournamentRanking] = useState<RankingEntry[]>([]);

  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData ?? {};
  const tournamentId = rawData?.id ?? rawData?.data?.id;
  const initialMoney = Number(attributes?.amount_start) || 1;

  useEffect(() => {
    const checkTournamentRanking = async () => {
      ///////////////////////////////////////////////////////
      if (tournamentId === 82 || tournamentId === 85) {
        setPriceReward('Name')
      }

      if (tournamentId === 87) {
        setPriceReward('Name_87')
      }

      if (tournamentId === 85) {
        setPriceReward('Name_more')
      }

      if (tournamentId === 120) {
        setPriceReward('Name_500')
      }

      if (tournamentId === 125) {
        setPriceReward('ranking_125')
      }

      if (tournamentId === 122) {
        setPriceReward('ranking_BL')
      }
      ///////////////////////////////////////////////////////
      if (tournamentId) {
        try {
          const apiData = await getTournamentRanking(tournamentId);
          setLocalTournamentRanking(apiData);
        } catch (error) {
          console.error('Error fetching tournament ranking:', error);
        }
      } else {
        setLocalTournamentRanking(tournamentRanking);
      }
    };

    checkTournamentRanking();

  }, [tournamentRanking, tournamentId]);


  return (
    <>
      <Title>{attributes?.name}</Title>

      <Row>
        <ContentPhoto>
          <img src={LogoDetails} alt="Img Logo Details" />
        </ContentPhoto>
        <ContentResults>
          <SubTitle>Current Results</SubTitle>
          <TournamentRank>

            {localTournamentRanking.map((entry) => {
              const totalUSDT = entry.totalInUSDT;
              const player = entry.username;
              const percentageChange = ((totalUSDT - initialMoney) / initialMoney) * 100;
              const isInvalidData = isNaN(totalUSDT) || isNaN(percentageChange);
              return (
                <TournamentList key={player}>
                  <WrappList className={player === username ? 'is_me' : ''}>
                    <TournamentBlet className={player === username ? 'is_me' : ''}>
                      <NickName className={priceReward}>{player}</NickName>
                      {!isInvalidData && (
                        <Percent>
                          {percentageChange > 0 ? `+${percentageChange.toFixed(2)}` : percentageChange.toFixed(2)}%
                        </Percent>
                      )}
                    </TournamentBlet>
                    {!isInvalidData && (
                      <Amount className={`${totalUSDT > initialMoney ? 'up_state' : totalUSDT < initialMoney ? 'down_state' : ''}`}>
                        {formatCurrency(totalUSDT)} {CASH_TICKER}
                      </Amount>
                    )}
                  </WrappList>
                </TournamentList>
              );
            })}
          </TournamentRank>
        </ContentResults>
      </Row>

      <BeltBottom>
        <p>Time left:</p>

        {(tournamentStatus === 'IN_PROGRESS' || tournamentStatus === 'BEFORE_START') ? (
          <>
            {(tournamentStatus === 'BEFORE_START') ? (
              <SubTitle className="inner">Coming Soon</SubTitle>
            ) : <TournamentCountdown date={attributes?.end_at} /> }
          </>
        ) : <LineText>Finished</LineText> }

      </BeltBottom>
      <Banner className={priceReward}>Sponsored by: <img src={LogoBanner} alt="Logo Banner" /></Banner>
    </>
  );
};

export default TournamentRanking;
